import React, { useEffect, useState, useCallback, useRef } from "react";
import ReactDOM from "react-dom";
import { CircularProgress, IconButton } from "@material-ui/core";
import BetterCircularProgress from "../../components/BetterCircularProgress";
import { BellIcon } from "@heroicons/react/24/solid";
import { getContadorNaoLidas, getNotificacoes, marcarComoLida } from "../../crud/notificacao.crud.js";
import styles from "../../styles/Notificacoes.module.scss";

const PER_PAGE = 15;

const formatarDataNotificacao = (data) => {
  if (!data) {
    return "";
  }

  const date = new Date(data);
  const dia = String(date.getDate()).padStart(2, "0");
  const mes = String(date.getMonth() + 1).padStart(2, "0");
  const ano = date.getFullYear();
  const horas = String(date.getHours()).padStart(2, "0");
  const minutos = String(date.getMinutes()).padStart(2, "0");

  return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
};

export default function Notificacoes() {
  const [contador, setContador] = useState(0);
  const [drawer, setDrawer] = useState(false);
  const [notificacoes, setNotificacoes] = useState([]);
  const [pagina_atual, setPaginaAtual] = useState(1);
  const [ultima_pagina, setUltimaPagina] = useState(1);
  const [carregando, setCarregando] = useState(false);
  const [carregando_mais, setCarregandoMais] = useState(false);

  const body_ref = useRef(null);

  const buscarContador = useCallback(async () => {
    try {
      const response = await getContadorNaoLidas();

      setContador(response.data?.contador || 0);
    } catch (_error) {}
  }, []);

  useEffect(() => {
    buscarContador();
  }, [buscarContador]);

  const carregarNotificacoes = useCallback(async (pagina, concatenar = false) => {
    if (concatenar) {
      setCarregandoMais(true);
    } else {
      setCarregando(true);
    }

    try {
      const response = await getNotificacoes(pagina, PER_PAGE);
      const dados = response.data;

      if (concatenar) {
        setNotificacoes((prev) => [...prev, ...dados.data]);
      } else {
        setNotificacoes(dados.data);
      }

      setPaginaAtual(dados.current_page);
      setUltimaPagina(dados.last_page);
    } catch (_error) {}

    setCarregando(false);
    setCarregandoMais(false);
  }, []);

  const abrirDrawer = () => {
    setDrawer(true);
    setNotificacoes([]);
    setPaginaAtual(1);
    setUltimaPagina(1);

    carregarNotificacoes(1);
  };

  const fecharDrawer = () => {
    setDrawer(false);

    buscarContador();
  };

  const handleScroll = () => {
    const container = body_ref.current;

    if (!container || carregando_mais) {
      return;
    }

    const distancia_do_fundo = container.scrollHeight - container.scrollTop - container.clientHeight;

    if (distancia_do_fundo < 100 && pagina_atual < ultima_pagina) {
      carregarNotificacoes(pagina_atual + 1, true);
    }
  };

  const handleClickNotificacao = async (destinatario) => {
    if (destinatario.nde_lida) {
      return;
    }

    try {
      await marcarComoLida(destinatario.id);

      setNotificacoes((prev) =>
        prev.map((item) => {
          if (item.id === destinatario.id) {
            return { ...item, nde_lida: true, nde_data_leitura: new Date().toISOString() };
          }

          return item;
        })
      );
    } catch (_error) {}
  };

  const tem_mais = pagina_atual < ultima_pagina;

  return (
    <>
      <div className="bell-notificacao">
        <IconButton onClick={abrirDrawer}>
          <span class="material-symbols-outlined">
            notifications
          </span>

          {contador > 0 && (
            <div className="nova-not">
            </div>
          )}
        </IconButton>
      </div>

      {drawer && ReactDOM.createPortal(
        <>
          <div className={styles.overlay} onClick={fecharDrawer} />

          <div className={styles.drawer}>
            <div className={styles.drawerHeader}>
              <p className={styles.drawerTitulo}>Notificações</p>
              <button className={styles.drawerFechar} onClick={fecharDrawer}>×</button>
            </div>

            <div
              className={styles.drawerBody}
              ref={body_ref}
              onScroll={handleScroll}
            >
              <BetterCircularProgress loading={carregando} />

              {!carregando && notificacoes.length === 0 && (
                <div className={styles.emptyState}>
                  <p>Nenhuma notificação</p>
                  <span>Você ainda não possui notificações.</span>
                </div>
              )}

              {notificacoes.map((destinatario) => (
                <div
                  key={destinatario.id}
                  className={`${styles.notificacaoItem} ${!destinatario.nde_lida ? styles.notificacaoNaoLida : ""}`}
                  onClick={() => handleClickNotificacao(destinatario)}
                >
                  <p className={styles.notificacaoTipo}>
                    {destinatario.notificacao?.not_titulo}
                  </p>
                  <p className={styles.notificacaoMensagem}>
                    {destinatario.notificacao?.not_mensagem}
                  </p>
                  <p className={styles.notificacaoData}>
                    {formatarDataNotificacao(destinatario.created_at)}
                  </p>
                </div>
              ))}

              {carregando_mais && (
                <div className={styles.loading}>
                  <CircularProgress size={24} color="inherit" />
                </div>
              )}

              {!carregando && !carregando_mais && notificacoes.length > 0 && !tem_mais && (
                <p className={styles.fimLista}>Não há mais notificações.</p>
              )}
            </div>
          </div>
        </>,
        document.body
      )}
    </>
  );
}
